import { state } from './state';
import { MessagingModule } from './MessagingModule';
import { notificationRenderer } from './components/Messaging';
import { ErrorModal } from './components/ErrorModal';


export { MessagingTypes, isInfoError, getErrorTitle } from './state';
export * from './state/actions';
export { withErrorHandler, withHideModal } from './state/sagas';

export {
    modalClassNames,
    ModalContext, withModalContext, useModalContext, createModal,
} from './components/Messaging';
export type { ModalComponent } from './components/Messaging';

export const messaging = {
    messaging: {
        notificationRenderer,
        modalTypes: {
            ErrorModal,
        },
    },
    state,
    renderChain: [
        [MessagingModule, 40],
    ],
};
